import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';

import { clearReduxData, setHasToken } from 'redux/dataStorage/actions';

import { captureLogout, captureFrequencyOfPDFDownloadsAfterLogout } from 'analytics';
import { Modal, WarningModalContent } from 'components/Common';
import { SessionContext } from 'components/Sessions/SessionContext';
import { minWidth } from 'themes';
import {
  getPDFDownloadsCount,
  handleSessionLogout,
  LOGOUT_STATUS_TYPES,
} from 'utilities/sessionUtilities';

const StyledModal = styled(Modal)`
  ${minWidth(
    'tablet',
    css`
      max-width: 384px;
    `
  )}
`;

interface IProps {
  mounted: boolean;
  dismissModal: () => void;
}

export const SessionExpiringModal = ({ mounted, dismissModal }: IProps) => {
  const dispatch = useDispatch();
  const sessionManager = useContext(SessionContext);

  const logout = () => {
    captureFrequencyOfPDFDownloadsAfterLogout(getPDFDownloadsCount());
    captureLogout();
    handleSessionLogout(LOGOUT_STATUS_TYPES.USER_INITIATED);
    dispatch(clearReduxData());
    dispatch(setHasToken(false));
    dismissModal();
    sessionManager.clearTimeouts();
  };

  return (
    <StyledModal
      mounted={mounted}
      titleText="session-expiring-modal"
      onExit={dismissModal}
      showCloseButton={false}
    >
      <WarningModalContent
        header="You have been inactive for some time"
        description="You will be automatically logged out soon."
        rejectionButtonText="Log&nbsp;out"
        handleRejection={logout}
        confirmationButtonText="Continue&nbsp;browsing"
        handleConfirmation={dismissModal}
      />
    </StyledModal>
  );
};

export default SessionExpiringModal;
